import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "left" }
const _hoisted_2 = ["data-text"]
const _hoisted_3 = {
  key: 0,
  class: "count"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_component_Button, {
    class: _normalizeClass(["pulse-button", {active: $props.active, small: $props.small}]),
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.value = !_ctx.value))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($props.icon)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              size: $options.c_icon_size,
              "stroke-width": "1",
              stroke: $props.color ? $props.color : 'var(--gray-light-600)',
              icon: $props.icon
            }, null, 8 /* PROPS */, ["size", "stroke", "icon"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: "text ellipsis",
          "data-text": $props.text
        }, _toDisplayString($props.text), 9 /* TEXT, PROPS */, _hoisted_2)
      ]),
      ($props.count !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.count), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}